import React, { useState } from 'react';
import Header from './header';
import { Sidebar } from './sidebar';
interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden bg-gray-50">
            <aside
                className="fixed left-0 top-0 h-screen transition-all duration-300 ease-in-out z-20"
                onMouseEnter={() => setIsSidebarExpanded(true)}
                onMouseLeave={() => setIsSidebarExpanded(false)}
            >
                <Sidebar isExpanded={isSidebarExpanded} />
            </aside>

            <div className={`flex-1 flex flex-col transition-all duration-300 ease-in-out ${isSidebarExpanded ? 'ml-52' : 'ml-14'}`}>
       
                <header className="sticky top-0 z-10 bg-white border-b border-gray-200">
                    <Header />
                </header>

                <main className="flex-0 overflow-y-auto bg-gray-50">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;